import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listStockMain } from '@/api/stock';
import { listBrand } from '@/api/brand.js';
import { barcodeParse } from '@/api/product.js';
export default {
  components: {},
  data: function data() {
    return {
      drawerTitle: '',
      drawerVisible: false,
      searchType: 1,
      detailList: [],
      loading: false,
      stockForm: {
        productName: '',
        productNumber: '',
        batch_number: '',
        specificationModel: '',
        manufacturer: '',
        trackingCode: '',
        barCode: '',
        barCode2: '',
        page: 1,
        pageSize: 10,
        total: 0,
        brandId: null,
        manufacturerId4: null,
        isVirtualWarehouse: 2
      },
      scanBarCode: null,
      brandList: [],
      warehouseList: [],
      selectedRows: [],
      time: 200,
      timeOut: null,
      salesTypeList: [{
        ID: 1,
        name: '直销报价单',
        type: 'success'
      }, {
        ID: 2,
        name: '临调销售单',
        type: 'primary'
      }, {
        ID: 3,
        name: '销售出货单',
        type: 'warning'
      }, {
        ID: 4,
        name: '有台报价单',
        type: 'warning'
      }, {
        ID: 6,
        name: '寄售销售单',
        type: 'warning'
      }],
      searchFormExpand: false
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    init: function init(_ref) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var manufacturerId, cusCode, barCode, batchNumber, trackingCode, that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                manufacturerId = _ref.manufacturerId, cusCode = _ref.cusCode, barCode = _ref.barCode, batchNumber = _ref.batchNumber, trackingCode = _ref.trackingCode;
                that = _this;
                that.drawerVisible = true;
                that.drawerTitle = '增加产品';
                that.detailList = [];
                that.stockForm.page = 1;
                that.stockForm.total = 0;
                that.stockForm.manufacturerId4 = manufacturerId;
                that.stockForm.cusCode = cusCode || null;
                that.stockForm.barCode = barCode || null;
                that.stockForm.batchNumber = batchNumber || null;
                that.stockForm.trackingCode = trackingCode || null;
                _context.next = 14;
                return that.loadBrand();

              case 14:
                _context.next = 16;
                return that.loadStock();

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    drawerClose: function drawerClose() {
      var that = this;
      that.drawerVisible = false;
    },
    loadBrand: function loadBrand() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, form;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;
                form = {
                  page: 1,
                  pageSize: 9999
                };
                _context2.next = 4;
                return listBrand(form).then(function (res) {
                  that.brandList = res.list;
                }).catch(function () {});

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    importConfirm: function importConfirm() {
      var that = this;
      var data = that.$refs.detailListTable.selection;
      console.log('data', data);

      if (data.length < 1) {
        that.$message.error('请选择要导入的数据');
      } else {
        that.$emit('confirm', data);
        that.drawerClose();
      }
    },
    // 将选中的数据添加到订单耗材明细列表中
    stockAddToList: function stockAddToList() {
      var that = this;
      var stockList = that.selectedRows;

      if (stockList.length < 1) {
        that.$message.error('请选择要添加的产品');
      } else {
        console.log('stockList', stockList);
        that.$emit('confirm', stockList);
      }
    },
    stockListPageChange: function stockListPageChange(page) {
      var that = this;
      that.stockForm.page = page;
      that.loadStock();
    },
    stockListSizeChange: function stockListSizeChange(val) {
      var that = this;
      that.stockForm.page = 1;
      that.stockForm.pageSize = val;
      that.loadStock();
    },
    loadStock: function loadStock() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, form;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this3;
                that.loading = true;
                form = JSON.parse(JSON.stringify(that.stockForm));

                if (form.barCode) {
                  if (form.barCode.substring(0, 2) === '01') {
                    form.barCode = form.barCode.substring(2);
                  }
                }

                _context3.next = 6;
                return listStockMain(form).then(function (res) {
                  that.detailList = that.stockListFormat(res.list);
                  that.stockForm.total = res.total;
                }).catch(function (e) {}).finally(function () {
                  that.loading = false;

                  if (that.stockForm.barCode) {
                    that.$refs.barcodeInput.focus();
                  }
                });

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    stockListFormat: function stockListFormat(rows) {
      var resultRows = [];
      rows.forEach(function (row, index) {
        resultRows.push({
          ID: row.ID,
          mainId: row.main_id,
          specsId: row.specs_id,
          inventoryId: row.ID,
          rowIndex: index,
          productNumber: row.specs.productNumber,
          productName: row.main.productName,
          specificationModel: row.specs.specificationModel,
          batchNumber: row.batch_number,
          salesQuantity: row.quantityUsed,
          stockQuantity: row.stock_quantity,
          normalQuantity: row.normalQuantity,
          consumedQuantity: row.consumedQuantity,
          receiptQuantity: row.receiptQuantity,
          issueLocking: row.issueLocking,
          salesPendingApproval: row.salesPendingApproval,
          productPackageLocking: row.productPackageLocking,
          unit: row.specs.unit,
          packUnit: row.specs.packUnit,
          packNum: row.specs.packNum,
          unitPrice: row.specs.wholesalePrice,
          registrationNumber: row.registrationNumber,
          manufacturerDate: row.manufacturer_date,
          validityDate: row.validity_date,
          expirationDate: row.main.expirationDate,
          productPlace: row.main.productPlace,
          brandName: row.main.brandName,
          sterilizationBatchNumber: row.sterilization_batch_number,
          sterilizationDate: row.sterilization_date,
          wholesalePurchasePrice: row.specs.wholesalePurchasePrice,
          consignmentPurchasePrice: row.specs.consignmentPurchasePrice,
          marketPrice: row.specs.marketPrice,
          consignmentPrice: row.specs.consignmentPrice,
          wholesalePrice: row.specs.wholesalePrice,
          sterilizationWays: row.specs.sterilizationWays,
          trackingCode: row.trackingCode || null,
          afterTaxPrice: Number(Number(row.afterTaxPrice).toFixed(2)),
          genericName: row.specs.genericName,
          manufacturerName: row.manufacturerName,
          medCode: row.specs.medCode,
          manufacturer: row.main.manufacturer,
          returnQuantity: 0,
          barCode: row.specs.barCode,
          sumPrice: Number(Number(row.returnQuantity * row.afterTaxPrice).toFixed(2))
        });
      });
      return resultRows;
    },
    stockFormSubmit: function stockFormSubmit() {
      var that = this;
      that.stockForm.page = 1;
      that.stockForm.total = 0;
      that.loadStock();
    },
    parseBarCode: function parseBarCode() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, form;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;

                if (that.scanBarCode) {
                  _context4.next = 4;
                  break;
                }

                that.$message.error('请扫描产品条码副码');
                return _context4.abrupt("return");

              case 4:
                form = {
                  pi: that.scanBarCode
                };
                that.scanBarCode = '';
                _context4.next = 8;
                return barcodeParse(form).then(function (res) {
                  that.stockForm.batchNumber = res.batch_number;
                  that.stockFormSubmit();
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    indexMethod: function indexMethod(index, pagination) {
      return (pagination.page - 1) * pagination.pageSize + index + 1;
    },
    rowClick: function rowClick(row) {
      var that = this;
      that.$refs.detailListTable.toggleRowSelection(row);
    },
    rowDbClick: function rowDbClick(row, column, event) {
      var that = this;
      var stockList = [row];
      that.$emit('confirm', stockList);
    },
    selectable: function selectable(row, index) {
      if (row.normalQuantity > 0) {
        return true;
      } else {
        return false;
      }
    },
    rowClassName: function rowClassName(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;
      row.rowIndex = rowIndex;
    },
    selectionChange: function selectionChange(selection) {
      var that = this;
      selection.map(function (row) {
        if (row.returnQuantity < 1) {
          row.returnQuantity = 1;
        }
      });
    },
    warehouseIdChange: function warehouseIdChange(val) {
      var that = this;
      var findRow = that.warehouseList.find(function (item) {
        return item.ID === val;
      });
      that.stockForm.manufacturerId4 = findRow.manufacturerId;
      that.loadStock();
    }
  }
};